import type * as SchemaTypes from '../../../apolloClient.types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type UpdateAssessmentRunsMutationVariables = SchemaTypes.Exact<{
  id: SchemaTypes.Scalars['ObjectID']['input'];
  companyId: SchemaTypes.Scalars['ObjectID']['input'];
  input: SchemaTypes.UpdateAssessmentRunsInput;
}>;


export type UpdateAssessmentRunsMutation = (
  { __typename: 'Mutation' }
  & { updateAssessmentRuns: (
    { __typename: 'ErrorResponse' }
    & { fields?: SchemaTypes.Maybe<Array<(
      { __typename: 'ErrorOnField' }
      & Pick<SchemaTypes.ErrorOnField, 'field' | 'message'>
    )>> }
  ) | (
    { __typename: 'UpdateAssessmentRunsSuccessfulResponse' }
    & { result: Array<(
      { __typename: 'AssessmentRun' }
      & Pick<SchemaTypes.AssessmentRun, 'id' | 'name'>
    )> }
  ) }
);


export const UpdateAssessmentRunsDocument = /*#__PURE__*/ gql`
    mutation UpdateAssessmentRuns($id: ObjectID!, $companyId: ObjectID!, $input: UpdateAssessmentRunsInput!) {
  updateAssessmentRuns(id: $id, companyId: $companyId, input: $input) {
    __typename
    ... on UpdateAssessmentRunsSuccessfulResponse {
      result {
        id
        name
      }
    }
    ... on ErrorResponse {
      fields {
        field
        message
      }
    }
  }
}
    `;
export type UpdateAssessmentRunsMutationFn = Apollo.MutationFunction<UpdateAssessmentRunsMutation, UpdateAssessmentRunsMutationVariables>;

/**
 * __useUpdateAssessmentRunsMutation__
 *
 * To run a mutation, you first call `useUpdateAssessmentRunsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAssessmentRunsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAssessmentRunsMutation, { data, loading, error }] = useUpdateAssessmentRunsMutation({
 *   variables: {
 *      id: // value for 'id'
 *      companyId: // value for 'companyId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAssessmentRunsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAssessmentRunsMutation, UpdateAssessmentRunsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAssessmentRunsMutation, UpdateAssessmentRunsMutationVariables>(UpdateAssessmentRunsDocument, options);
      }
export type UpdateAssessmentRunsMutationHookResult = ReturnType<typeof useUpdateAssessmentRunsMutation>;
export type UpdateAssessmentRunsMutationResult = Apollo.MutationResult<UpdateAssessmentRunsMutation>;
export type UpdateAssessmentRunsMutationOptions = Apollo.BaseMutationOptions<UpdateAssessmentRunsMutation, UpdateAssessmentRunsMutationVariables>;